import request from 'superagent';
import {getErrorMessageForNonStandardAndStandardResponse} from "./NetworkErrorUtil";

const JWT_TOKEN_REGEX = /^e[yw][A-Za-z0-9-_]+\.(?:e[yw][A-Za-z0-9-_]+)?\.[A-Za-z0-9-_]{2,}(?:(?:\.[A-Za-z0-9-_]{2,}){2})?$/;

export const TokenVerificationResult = Object.freeze({
  VALID: 'VALID',
  INVALID: 'INVALID',
  EXPIRED: 'EXPIRED',
  ERROR: 'ERROR',
});

export const isJwtTokenValid = (token) => {
  return JWT_TOKEN_REGEX.test(token);
};

const formatTokenVerificationResponse = (tokenVerificationResult, message) => {
  return {
    status: tokenVerificationResult,
    message,
  };
};

export const VerifyToken = (token: string, apiEndpoint: string, callback: () => void) => {

  if (!isJwtTokenValid(token)) {
    callback(formatTokenVerificationResponse(TokenVerificationResult.INVALID, "Invalid token"));
    return;
  }

  request.post(apiEndpoint)
    .send({ token })
    .then((response) => {
      const { status, body } = response;
      if (status === 202) {
        callback(formatTokenVerificationResponse(TokenVerificationResult.VALID, body.message));
      } else {
        callback(formatTokenVerificationResponse(TokenVerificationResult.INVALID, body.message));
      }
    })
    .catch((error) => {
      callback(formatTokenVerificationResponse(TokenVerificationResult.INVALID, getErrorMessageForNonStandardAndStandardResponse(error)));
    })
    .finally(() => {
      // Do nothing
    });
};